import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.scss";
import { message, Modal, Select, Switch } from "antd";
import actionBtn from "../../../assets/CreateSet/actionBtn.svg";
import Button from "../../../common/Button";
import {
  useAddAngleSetToMarketPlace,
  useUpdateAngleSetToMarketPlace,
} from "../../../hooks/useGuidelines";
import ChangeAngleView from "../ChangeAngleView";
import { useNavigate, useParams } from "react-router-dom";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";
const SequentialDetail = ({
  imageData,
  anglesList,
  sequenceUpdated,
  markAngleChangeUpdate,
  update,
  isDisabled,
}) => {
  const params = useParams();
  const headingWrapperRef = useRef(null);
  const listScrollableWrapperRefs = useRef([]);
  const [anglesData, setAnglesData] = useState([]);
  const fileFormats = ["jpg", "png", "tiff", "webp"];
  const fromCropType = [
    "At Object Boundry",
    "Above Nose",
    "Below Nose",
    "At Shoulders",
    "Below Chest",
    "At Waist",
    "At Hips",
    "At Wrist",
    "Above Knees",
    "At Knees",
    "At Mid Calf",
    "At Ankles",
  ];
  const toCropType = [
    "Above Nose",
    "Below Nose",
    "At Shoulders",
    "Below Chest",
    "At Waist",
    "At Hips",
    "At Wrist",
    "Above Knees",
    "At Knees",
    "At Mid Calf",
    "At Ankles",
    "At Object Boundry",
  ];
  const shadowType = ["Natural", "Drop", "Inner", "Outer", "None"];
  const [isChangeAngleView, setIsChangeAngleView] = useState(false);
  const { guide_selectedGuidelLineId, guide_selectedClientId } = useContext(
    GuidelinesSelectedCategoryContext
  );
  const [selectedAngle, setSelectedAngle] = useState("");
  const navigate = useNavigate();

  const createData = () => {
    const angles = imageData.map((data, index) => {
      const { _id: angleGlobal, image, name, isActive } = data;
      return {
        seqNo: index + 1,
        angleGlobal,
        angleImage: image?.thumbPath?.url,
        adaptation: {
          name,
          dimensions: {
            height: 1080,
            width: 1920,
          },
          dpi: 300,
          colorMode: "sRGB IEC61966-2.1",
          background: {
            rgb: [255, 255, 255],
          },
          backgroundColorType: "rgb",
          margins: {
            top: 10,
            right: 15,
            bottom: 10,
            left: 15,
          },
          alignment: "center",
          shadow: "None",
          cropType: {
            name: "manual",
            from: "At Object Boundry",
            to: "At Object Boundry",
          },
          fileFormat: "jpg",
          maxFileSize: 50,
          isActive,
        },
      };
    });

    setAnglesData(angles);
  };
  const updateData = () => {
    let angles = [];
    imageData.map((data, index) => {
      if (data.imageSetsData) {
        angles.push({
          seqNo: index + 1,
          angleGlobal: data?.imageSetsData.angleGlobal._id,
          angleImage: data?.imageSetsData.angleGlobal.image.thumbPath.url,
          adaptation: data.imageSetsData.adaptation,
        });
      } else {
        angles.push({
          seqNo: index + 1,
          angleGlobal: data?._id,
          angleImage: data?.image.thumbPath.url,
          adaptation: {
            name: data?.name,
            dimensions: {
              height: 1080,
              width: 1920,
            },
            dpi: 300,
            colorMode: "RGB",
            background: {
              rgb: [255, 255, 255],
            },
            backgroundColorType: "rgb",
            margins: {
              top: 10,
              right: 15,
              bottom: 10,
              left: 15,
            },
            alignment: "center",
            shadow: "none",
            cropType: {
              name: "manual",
              from: "At Object Boundry",
              to: "At Object Boundry",
            },
            fileFormat: "jpg",
            maxFileSize: 50,
            isActive: data.isActive,
          },
        });
      }
    });
    setAnglesData(angles);
  };

  useEffect(() => {
    !update ? createData() : updateData();
  }, []);

  const handleScroll = (e) => {
    const { scrollTop } = e.target;
    if (e.target === headingWrapperRef.current) {
      listScrollableWrapperRefs.current.forEach((ref) => {
        if (ref) ref.scrollTop = scrollTop;
      });
    } else {
      headingWrapperRef.current.scrollTop = scrollTop;
      listScrollableWrapperRefs.current.forEach((ref) => {
        if (ref !== e.target) {
          ref.scrollTop = scrollTop;
        }
      });
    }
  };
  const handleBackgroundChange = (index, value) => {
    const updatedAnglesData = [...anglesData];
    updatedAnglesData[index].adaptation.background = {
      [value]: updatedAnglesData[index].adaptation.background[value] || "",
    };
    updatedAnglesData[index].adaptation.backgroundColorType = value;
    setAnglesData(updatedAnglesData);
  };
  const handleBackgroundValueChange = (index, value, rgbIndex = null) => {
    const updatedAnglesData = [...anglesData];
    const backgroundType = !update
      ? Object.keys(updatedAnglesData[index].adaptation.background)[0]
      : updatedAnglesData[index].adaptation.backgroundColorType;

    if (backgroundType === "hex") {
      updatedAnglesData[index].adaptation.background.hex = value;
    } else if (backgroundType === "rgb" || backgroundType === "cmyk") {
      if (
        !Array.isArray(
          updatedAnglesData[index].adaptation.background[backgroundType]
        )
      ) {
        updatedAnglesData[index].adaptation.background[backgroundType] = [];
      }
      updatedAnglesData[index].adaptation.background[backgroundType][rgbIndex] =
        value;
    } else {
      updatedAnglesData[index].adaptation.background[backgroundType] = value;
    }

    setAnglesData(updatedAnglesData);
  };

  const handleChange = (index, field, value) => {
    const updatedAngles = anglesData.map((angle, idx) => {
      if (idx === index) {
        return {
          ...angle,
          adaptation: {
            ...angle.adaptation,
            [field]: value,
          },
        };
      }
      return angle;
    });
    setAnglesData(updatedAngles);
  };
  const handleFileFormatsChange = (index, format) => {
    const updatedAngles = anglesData.map((angle, idx) => {
      if (idx === index) {
        return {
          ...angle,
          adaptation: {
            ...angle.adaptation,
            fileFormat: format,
          },
        };
      }
      return angle;
    });
    setAnglesData(updatedAngles);
  };
  const onSuccess = (res) => {
    if (res.status === 200) {
      update
        ? message.success("Angle Set  Updated Successfully.")
        : message.success("Angle Set  Created Successfully.");
      setTimeout(() => {
        sequenceUpdated();
        navigate("/");
      }, 2000);
    }
  };
  const onError = (err) => {
    message.error(err);
  };
  const { mutate: addAngleToMarketPlace } = useAddAngleSetToMarketPlace(
    onSuccess,
    onError
  );

  const { mutate: updateAngleSetToMarketPlace } =
    useUpdateAngleSetToMarketPlace(onSuccess, onError);

  const handleSubmit = () => {
    const processedAngles = anglesData.map((angle) => {
      const { angleImage, ...rest } = angle; // Exclude angleImage
      return rest;
    });

    const payload = {
      guidelineId: guide_selectedGuidelLineId,
      angleSetData: {
        name: "",
        angles: processedAngles, // Use processed angles
      },
      orgId: null,
    };

    const updatedPayload = {
      guidelineId: guide_selectedGuidelLineId,
      angleSetData: {
        name: "",
        angles: processedAngles, // Use processed angles
      },
      orgId: null,
      angleSetId: params.angleSetId,
    };

    update
      ? updateAngleSetToMarketPlace(updatedPayload)
      : addAngleToMarketPlace(payload);
  };

  const handleChangeAngle = (angleId) => {
    setSelectedAngle(angleId);
    setIsChangeAngleView(true);
  };
  const markAngleChangeDone = (
    updatedAngleId,
    updatedAngleImage,
    updatedAngleData
  ) => {
    const data = [...anglesData];
    for (let i = 0; i < data.length; i++) {
      if (data[i].angleGlobal === selectedAngle) {
        data[i].angleGlobal = updatedAngleId;
        data[i].angleImage = updatedAngleImage;
      }
    }
    setAnglesData(data);
    setIsChangeAngleView(false);
    markAngleChangeUpdate(selectedAngle, updatedAngleId, updatedAngleData);
  };

  const getChangeAngleViewModal = () => {
    return (
      <Modal
        title="Change - Angle"
        open={isChangeAngleView}
        footer={null}
        width="80%"
        height="90dvh"
        className="change_angle_view_modal_wrapper"
        onCancel={() => setIsChangeAngleView(false)}
      >
        <ChangeAngleView
          anglesList={anglesList}
          activeAngle={selectedAngle}
          // handleChangeAngle={handleAngleUpdate}
          markAngleChangeDone={markAngleChangeDone}
        />
      </Modal>
    );
  };
  return (
    <div className="sequential_detail_wrapper">
      <div className="sequential_content">
        <div className="heading_section">
          <div className="empty_container"></div>
          <div className="heading">Sequence No.</div>
          <div
            className="heading_wrapper"
            ref={headingWrapperRef}
            onScroll={handleScroll}
          >
            <div className="heading">Change Angle View</div>
            <div className="heading">Dimension (in pixels)(W*H)</div>
            <div className="heading"> DPI</div>
            <div className="heading">Alignment</div>
            <div className="heading" style={{ marginBottom: "140px" }}>
              Margin (in pixels)
            </div>
            <div className="heading">Color Mode</div>
            <div className="heading">Background</div>
            <div className="heading margin"> Shadow</div>
            <div className="heading" style={{ marginBottom: "130px" }}>
              Crop Type
            </div>
            <div className="heading">File Formats</div>
            <div className="heading">Max file size (in MB)</div>
            {/* <div className="heading" style={{ marginBottom: "0px" }}>
              is Active
            </div> */}
          </div>
        </div>
        <div className="list_section">
          {!isDisabled
            ? anglesData.map((list, index) => {
                return (
                  <div
                    className="list_item_wrapper"
                    key={`${list.angleGlobal} ${index}`}
                  >
                    <div className="empty_container">
                      <img src={list.angleImage} alt={list.adaptation.name} />
                    </div>
                    <div className="sequence_number">{list.seqNo}</div>
                    <div
                      className="list_scrollable_wrapper"
                      ref={(el) =>
                        (listScrollableWrapperRefs.current[index] = el)
                      }
                      onScroll={handleScroll}
                      key={list.angleGlobal}
                    >
                      <button
                        className="changeBtn"
                        onClick={() => handleChangeAngle(list?.angleGlobal)}
                      >
                        Change
                      </button>
                      <div className="dimension_wrapper">
                        <input
                          className="width_wrapper"
                          value={list.adaptation.dimensions.width}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (/^\d+$/.test(value)) {
                              handleChange(index, "dimensions", {
                                ...list.adaptation.dimensions,
                                width: value === "" ? "" : Number(value),
                              });
                            }
                          }}
                        />
                        {""}
                        <div className="cross_icon_wrapper">x</div>
                        <input
                          className="height_wrapper"
                          value={list.adaptation.dimensions.height}
                          // onChange={(e) => {
                          //   const { value } = e.target;
                          //   if (/^\d+$/.test(value)) {
                          //     handleChange(index, "dimensions", {
                          //       ...list.adaptation.dimensions,
                          //       height: value === "" ? "" : Number(value),
                          //     });
                          //   }
                          // }}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (!isNaN(value)) {
                              handleChange(index, "dimensions", {
                                ...list.adaptation.dimensions,
                                height: value === "" ? "" : Number(value),
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="dpi_input_wrapper">
                        <input
                          className="dpi_input"
                          value={list.adaptation.dpi}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(value)) {
                              handleChange(index, "dpi", value);
                            }
                          }}
                          // onChange={(e) => {
                          //   const { value } = e.target;
                          //   if (/^\d+$/.test(value)) {
                          //     handleChange(index, "dpi", {
                          //       ...list.adaptation.dpi,
                          //       dpi: value === "" ? "" : Number(value),
                          //     });
                          //   }
                          // }}
                        />
                      </div>
                      <div className="alignment_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          value={list.adaptation.alignment}
                          onChange={(value) =>
                            handleChange(index, "alignment", value)
                          }
                        >
                          <Select.Option value="top">Top</Select.Option>
                          <Select.Option value="right">Right</Select.Option>
                          <Select.Option value="bottom">Bottom</Select.Option>
                          <Select.Option value="center">Center</Select.Option>
                          <Select.Option value="left">Left</Select.Option>
                        </Select>
                      </div>
                      <div className="margin_wrapper">
                        <div className="col_one">
                          <input
                            className="left_margin"
                            value={list.adaptation.margins.left}
                            onChange={(e) => {
                              const { value } = e.target;
                              if (/^\d+$/.test(value)) {
                                handleChange(index, "margins", {
                                  ...list.adaptation.margins,
                                  left: value === "" ? "" : Number(value),
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="col_two">
                          <input
                            className="top_margin"
                            value={list.adaptation.margins.top}
                            onChange={(e) => {
                              const { value } = e.target;
                              if (/^\d+$/.test(value)) {
                                handleChange(index, "margins", {
                                  ...list.adaptation.margins,
                                  top: value === "" ? "" : Number(value),
                                });
                              }
                            }}
                          />
                          <div className="buttons_wrapper">
                            <div className="left_btn_wrapper">
                              <img src={actionBtn} alt="actionBtn" />
                            </div>
                            <div className="center_btn_wrapper">
                              <div className="top_btn_wrapper">
                                <img src={actionBtn} alt="actionBtn" />
                              </div>
                              <div className="empty_wrapper" />
                              <div className="bottom_btn_wrapper">
                                <img src={actionBtn} alt="actionBtn" />
                              </div>
                            </div>
                            <div className="right_btn_wrapper">
                              <img src={actionBtn} alt="actionBtn" />
                            </div>
                          </div>
                          <input
                            className="bottom_margin"
                            value={list.adaptation.margins.bottom}
                            onChange={(e) => {
                              const { value } = e.target;
                              if (/^\d+$/.test(value)) {
                                handleChange(index, "margins", {
                                  ...list.adaptation.margins,
                                  bottom: value === "" ? "" : Number(value),
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="col_three">
                          <input
                            className="right_margin"
                            value={list.adaptation.margins.right}
                            onChange={(e) => {
                              const { value } = e.target;
                              if (/^\d+$/.test(value)) {
                                handleChange(index, "margins", {
                                  ...list.adaptation.margins,
                                  right: e.target.value,
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="color_mode_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          value={list.adaptation.colorMode}
                          onChange={(value) =>
                            handleChange(index, "colorMode", value)
                          }
                        >
                          {/* <Select.Option value="HEX">Hex</Select.Option>
                          <Select.Option value="PANTONE">Pantone</Select.Option>
                          <Select.Option value="RGB">RGB</Select.Option> */}
                          <Select.Option value="sRGB">sRGB</Select.Option>
                          <Select.Option value="sRGB IEC61966-2.1">
                            sRGB IEC61966-2.1
                          </Select.Option>
                        </Select>
                      </div>
                      <div className="background_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          onChange={(value) =>
                            handleBackgroundChange(index, value)
                          }
                          value={
                            !update
                              ? Object.keys(list.adaptation?.background)[0]
                              : list.adaptation.backgroundColorType
                          }
                        >
                          <Select.Option value="hex">Hex</Select.Option>
                          <Select.Option value="pantone">Pantone</Select.Option>
                          <Select.Option value="rgb">RGB</Select.Option>
                          <Select.Option value="cmyk">CMYK</Select.Option>
                        </Select>
                        {!update ? (
                          <div className="input_wrapper">
                            {Object.keys(list.adaptation.background)[0] ===
                              "hex" && (
                              <input
                                className="backgroundInput"
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  handleBackgroundValueChange(
                                    index,
                                    inputValue.startsWith("#")
                                      ? inputValue
                                      : "#" + inputValue.replace(/#/g, "")
                                  );
                                }}
                                onBlur={(e) => {
                                  const inputValue = e.target.value;
                                  const hexPattern =
                                    /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
                                  if (!hexPattern.test(inputValue)) {
                                    message.error(
                                      "Please enter a valid hex color code."
                                    );
                                  }
                                }}
                                value={
                                  list.adaptation.background.hex?.startsWith(
                                    "#"
                                  )
                                    ? list.adaptation.background.hex
                                    : "#" + list.adaptation.background.hex
                                }
                              />
                            )}

                            {(Object.keys(list.adaptation.background)[0] ===
                              "rgb" ||
                              Object.keys(list.adaptation.background)[0] ===
                                "cmyk") && (
                              <>
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isRgb =
                                      Object.keys(
                                        list.adaptation.background
                                      )[0] === "rgb";
                                    const isValid =
                                      /^\d{1,3}$/.test(value) &&
                                      Number(value) >= 0 &&
                                      Number(value) <= (isRgb ? 255 : 100);
                                    if (isValid || value === "") {
                                      handleBackgroundValueChange(
                                        index,
                                        value,
                                        0
                                      );
                                    }
                                  }}
                                  value={
                                    list.adaptation.background[
                                      Object.keys(list.adaptation.background)[0]
                                    ][0] || ""
                                  }
                                />
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isRgb =
                                      Object.keys(
                                        list.adaptation.background
                                      )[0] === "rgb";
                                    const isValid =
                                      /^\d{1,3}$/.test(value) &&
                                      Number(value) >= 0 &&
                                      Number(value) <= (isRgb ? 255 : 100);
                                    if (isValid || value === "") {
                                      handleBackgroundValueChange(
                                        index,
                                        value,
                                        1
                                      );
                                    }
                                  }}
                                  value={
                                    list.adaptation.background[
                                      Object.keys(list.adaptation.background)[0]
                                    ][1] || ""
                                  }
                                />
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isRgb =
                                      Object.keys(
                                        list.adaptation.background
                                      )[0] === "rgb";
                                    const isValid =
                                      /^\d{1,3}$/.test(value) &&
                                      Number(value) >= 0 &&
                                      Number(value) <= (isRgb ? 255 : 100);
                                    if (isValid || value === "") {
                                      handleBackgroundValueChange(
                                        index,
                                        value,
                                        2
                                      );
                                    }
                                  }}
                                  value={
                                    list.adaptation.background[
                                      Object.keys(list.adaptation.background)[0]
                                    ][2] || ""
                                  }
                                />
                                {Object.keys(list.adaptation.background)[0] ===
                                  "cmyk" && (
                                  <input
                                    className="backgroundInput"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const isValid =
                                        /^\d{1,3}$/.test(value) &&
                                        Number(value) >= 0 &&
                                        Number(value) <= 100;
                                      if (isValid || value === "") {
                                        handleBackgroundValueChange(
                                          index,
                                          value,
                                          3
                                        );
                                      }
                                    }}
                                    value={
                                      list.adaptation.background[
                                        Object.keys(
                                          list.adaptation.background
                                        )[0]
                                      ][3] || ""
                                    }
                                  />
                                )}
                              </>
                            )}

                            {Object.keys(list.adaptation.background)[0] ===
                              "pantone" && (
                              <input
                                className="backgroundInput"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const isValid = String(value);
                                  if (isValid || value === "") {
                                    handleBackgroundValueChange(index, value);
                                  }
                                }}
                                value={list.adaptation.background.pantone}
                              />
                            )}
                          </div>
                        ) : (
                          <div className="input_wrapper">
                            {
                              // Object.keys(list.adaptation.background).find((key) =>
                              //   Array.isArray(list.adaptation.background[key])
                              //     ? list.adaptation.background[key].length > 0
                              //     : list.adaptation.background[key]
                              // )
                              list?.adaptation?.backgroundColorType ===
                                "hex" && (
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleBackgroundValueChange(
                                      index,
                                      inputValue.startsWith("#")
                                        ? inputValue
                                        : "#" + inputValue.replace(/#/g, "")
                                    );
                                  }}
                                  onBlur={(e) => {
                                    const inputValue = e.target.value;
                                    const hexPattern =
                                      /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
                                    if (!hexPattern.test(inputValue)) {
                                      message.error(
                                        "Please enter a valid hex color code."
                                      );
                                    }
                                  }}
                                  value={
                                    list.adaptation.background.hex?.startsWith(
                                      "#"
                                    )
                                      ? list.adaptation.background.hex
                                      : "#" + list.adaptation.background.hex
                                  }
                                />
                              )
                            }

                            {(list.adaptation.backgroundColorType === "rgb" ||
                              list.adaptation.backgroundColorType ===
                                "cmyk") && (
                              <>
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isRgb =
                                      Object.keys(
                                        list.adaptation.background
                                      )[0] === "rgb";
                                    const isValid =
                                      /^\d{1,3}$/.test(value) &&
                                      Number(value) >= 0 &&
                                      Number(value) <= (isRgb ? 255 : 100);
                                    if (isValid || value === "") {
                                      handleBackgroundValueChange(
                                        index,
                                        value,
                                        0
                                      );
                                    }
                                  }}
                                  value={
                                    list.adaptation.background[
                                      list.adaptation.backgroundColorType
                                    ]?.[0] || ""
                                  }
                                  placeholder="0"
                                />
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isRgb =
                                      Object.keys(
                                        list.adaptation.background
                                      )[0] === "rgb";
                                    const isValid =
                                      /^\d{1,3}$/.test(value) &&
                                      Number(value) >= 0 &&
                                      Number(value) <= (isRgb ? 255 : 100);
                                    if (isValid || value === "") {
                                      handleBackgroundValueChange(
                                        index,
                                        value,
                                        1
                                      );
                                    }
                                  }}
                                  value={
                                    list.adaptation.background[
                                      list.adaptation.backgroundColorType
                                    ]?.[1] || ""
                                  }
                                  placeholder="0"
                                />
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isRgb =
                                      Object.keys(
                                        list.adaptation.background
                                      )[0] === "rgb";
                                    const isValid =
                                      /^\d{1,3}$/.test(value) &&
                                      Number(value) >= 0 &&
                                      Number(value) <= (isRgb ? 255 : 100);
                                    if (isValid || value === "") {
                                      handleBackgroundValueChange(
                                        index,
                                        value,
                                        2
                                      );
                                    }
                                  }}
                                  value={
                                    list.adaptation.background[
                                      list.adaptation.backgroundColorType
                                    ]?.[2] || ""
                                  }
                                  placeholder="0"
                                />
                                {list.adaptation.backgroundColorType ===
                                  "cmyk" && (
                                  <input
                                    className="backgroundInput"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const isValid =
                                        /^\d{1,3}$/.test(value) &&
                                        Number(value) >= 0 &&
                                        Number(value) <= 100;
                                      if (isValid || value === "") {
                                        handleBackgroundValueChange(
                                          index,
                                          value,
                                          3
                                        );
                                      }
                                    }}
                                    value={
                                      list.adaptation.background[
                                        list.adaptation.backgroundColorType
                                      ]?.[3] || ""
                                    }
                                    placeholder="0"
                                  />
                                )}
                              </>
                            )}

                            {
                              // Object.keys(list.adaptation.background)[0]
                              list?.adaptation?.backgroundColorType ===
                                "pantone" && (
                                <input
                                  className="backgroundInput"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isValid = String(value);
                                    if (isValid || value === "") {
                                      handleBackgroundValueChange(index, value);
                                    }
                                  }}
                                  value={
                                    list?.adaptation?.background?.pantone || ""
                                  }
                                />
                              )
                            }
                          </div>
                        )}
                      </div>

                      <div className="shadow_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          value={list.adaptation.shadow}
                          onChange={(value) =>
                            handleChange(index, "shadow", value)
                          }
                        >
                          {shadowType.map((type) => (
                            <Select.Option key={type} value={type}>
                              {type}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                      <div className="crop_type_wrapper">
                        <input
                          placeholder="name"
                          value={list.adaptation.cropType.name}
                          onChange={(e) =>
                            handleChange(index, "cropType", {
                              ...list.adaptation.cropType,
                              name: e.target.value,
                            })
                          }
                        />

                        <Select
                          value={list.adaptation.cropType.from}
                          onChange={(value) =>
                            handleChange(index, "cropType", {
                              ...list.adaptation.cropType,
                              from: value,
                            })
                          }
                        >
                          {fromCropType.map((type) => (
                            <Select.Option value={type}>{type}</Select.Option>
                          ))}
                        </Select>
                        <Select
                          value={list.adaptation.cropType.to}
                          onChange={(value) =>
                            handleChange(index, "cropType", {
                              ...list.adaptation.cropType,
                              to: value,
                            })
                          }
                        >
                          {toCropType.map((type) => (
                            <Select.Option value={type}>{type}</Select.Option>
                          ))}
                        </Select>
                      </div>
                      <div className="file_formats_wrapper">
                        {fileFormats.map((format) => (
                          <div key={format} className="input_wrapper">
                            <input
                              type="radio"
                              checked={list.adaptation.fileFormat === format}
                              onChange={(e) =>
                                handleFileFormatsChange(
                                  index,
                                  format,
                                  e.target.checked
                                )
                              }
                            />
                            <label>{format.toUpperCase()}</label>
                          </div>
                        ))}
                      </div>
                      <div className="file_size_wrapper">
                        <input
                          className="file_size_input"
                          value={list.adaptation.maxFileSize}
                          onChange={(e) =>
                            handleChange(index, "maxFileSize", e.target.value)
                          }
                        />
                      </div>
                      {/* <div className="active_wrapper">
                    <label>InActive</label>
                    <Switch
                      value={list.adaptation.isActive}
                      onChange={(checked) =>
                        handleChange(index, "isActive", checked)
                      }
                    />
                    <label>Active</label>
                    <Select style={{ width: "100%", height: "30px" }}></Select>
                  </div> */}
                    </div>
                  </div>
                );
              })
            : imageData.map((list, index) => {
                return (
                  <div className="list_item_wrapper" key={list.angleGlobal._id}>
                    <div className="empty_container">
                      <img
                        src={list.angleGlobal.image.thumbPath.url}
                        alt={list.adaptation.name}
                      />
                    </div>
                    <div className="sequence_number">{list.seqNo}</div>
                    <div
                      className="list_scrollable_wrapper"
                      ref={(el) =>
                        (listScrollableWrapperRefs.current[index] = el)
                      }
                      onScroll={handleScroll}
                      key={list.angleGlobal._id}
                    >
                      <button disabled>Change</button>
                      <div className="dimension_wrapper">
                        <input
                          className="width_wrapper"
                          value={list.adaptation.dimensions.width}
                          disabled
                        />{" "}
                        <div className="cross_icon_wrapper">x</div>
                        <input
                          className="height_wrapper"
                          value={list.adaptation.dimensions.height}
                          disabled
                        />
                      </div>
                      <div className="dpi_input_wrapper">
                        <input
                          className="dpi_input"
                          value={list.adaptation.dpi}
                          disabled
                        />
                      </div>
                      <div className="alignment_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          value={list.adaptation.alignment}
                          disabled
                        >
                          <Select.Option value="center">Center</Select.Option>
                          <Select.Option value="left">Left</Select.Option>
                          <Select.Option value="right">Right</Select.Option>
                        </Select>
                      </div>
                      <div className="margin_wrapper">
                        <div className="col_one">
                          <input
                            className="left_margin"
                            value={list.adaptation.margins.left}
                            disabled
                          />
                        </div>
                        <div className="col_two">
                          <input
                            className="top_margin"
                            value={list.adaptation.margins.top}
                            disabled
                          />
                          <div className="buttons_wrapper">
                            <div className="left_btn_wrapper">
                              <img src={actionBtn} alt="actionBtn" />
                            </div>
                            <div className="center_btn_wrapper">
                              <div className="top_btn_wrapper">
                                <img src={actionBtn} alt="actionBtn" />
                              </div>
                              <div className="empty_wrapper" />
                              <div className="bottom_btn_wrapper">
                                <img src={actionBtn} alt="actionBtn" />
                              </div>
                            </div>
                            <div className="right_btn_wrapper">
                              <img src={actionBtn} alt="actionBtn" />
                            </div>
                          </div>
                          <input
                            className="bottom_margin"
                            value={list.adaptation.margins.bottom}
                            disabled
                          />
                        </div>
                        <div className="col_three">
                          <input
                            className="right_margin"
                            value={list.adaptation.margins.right}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="color_mode_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          value={list.adaptation.colorMode}
                          disabled
                        >
                          <Select.Option value="HEX">Hex</Select.Option>
                          <Select.Option value="PANTONE">Pantone</Select.Option>
                          <Select.Option value="RGB">RGB</Select.Option>
                        </Select>
                      </div>
                      <div className="background_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          value={list.adaptation?.backgroundColorType}
                          disabled
                        >
                          <Select.Option value="hex">Hex</Select.Option>
                          <Select.Option value="pantone">Pantone</Select.Option>
                          <Select.Option value="rgb">RGB</Select.Option>
                          <Select.Option value="cmyk">CMYK</Select.Option>
                          <Select.Option value="file">File</Select.Option>
                        </Select>
                        {/* <input
                      className="backgroundInput"
                      disabled
                      value={
                        list.adaptation.background[
                          Object.keys(list.adaptation.background)[0]
                        ]
                      }
                    /> */}
                        <div className="input_wrapper">
                          {list?.adaptation?.backgroundColorType === "hex" && (
                            <input
                              className="backgroundInput"
                              disabled
                              value={
                                list.adaptation.background.hex?.startsWith("#")
                                  ? list.adaptation.background.hex
                                  : "#" + list.adaptation.background.hex
                              }
                            />
                          )}

                          {(list.adaptation.backgroundColorType === "rgb" ||
                            list.adaptation.backgroundColorType === "cmyk") && (
                            <>
                              <input
                                className="backgroundInput"
                                disabled
                                value={
                                  list.adaptation.background[
                                    list.adaptation.backgroundColorType
                                  ]?.[0] || ""
                                }
                                placeholder="0"
                              />
                              <input
                                className="backgroundInput"
                                disabled
                                value={
                                  list.adaptation.background[
                                    list.adaptation.backgroundColorType
                                  ]?.[1] || ""
                                }
                                placeholder="0"
                              />
                              <input
                                className="backgroundInput"
                                disabled
                                value={
                                  list.adaptation.background[
                                    list.adaptation.backgroundColorType
                                  ]?.[2] || ""
                                }
                                placeholder="0"
                              />
                              {list.adaptation.backgroundColorType ===
                                "cmyk" && (
                                <input
                                  className="backgroundInput"
                                  disabled
                                  value={
                                    list.adaptation.background[
                                      list.adaptation.backgroundColorType
                                    ]?.[3] || ""
                                  }
                                  placeholder="0"
                                />
                              )}
                            </>
                          )}

                          {list?.adaptation?.backgroundColorType ===
                            "pantone" && (
                            <input
                              className="backgroundInput"
                              disabled
                              value={
                                list?.adaptation?.background?.pantone || ""
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="shadow_wrapper">
                        <Select
                          style={{ width: "100%", height: "30px" }}
                          value={list.adaptation.shadow}
                          disabled
                        >
                          <Select.Option value="none">None</Select.Option>
                        </Select>
                      </div>
                      <div className="crop_type_wrapper">
                        <input
                          placeholder="name"
                          value={list.adaptation.cropType.name}
                          disabled
                        />
                        <input
                          placeholder="From"
                          value={list.adaptation.cropType.from}
                          disabled
                        />
                        <input
                          placeholder="To"
                          value={list.adaptation.cropType.to}
                          disabled
                        />
                      </div>
                      <div className="file_formats_wrapper">
                        {fileFormats.map((format) => (
                          <div key={format} className="input_wrapper">
                            <input
                              type="radio"
                              checked={list?.adaptation?.fileFormat === format}
                              disabled
                            />
                            <label>{format.toUpperCase()}</label>
                          </div>
                        ))}
                      </div>
                      <div className="file_size_wrapper">
                        <input
                          className="file_size_input"
                          value={list.adaptation.maxFileSize}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
      <div className="action_container">
        {isDisabled ? (
          ""
        ) : (
          <Button
            width="90px"
            text="Done"
            height="40px"
            handleClick={handleSubmit}
          />
        )}
      </div>
      {isChangeAngleView && getChangeAngleViewModal()}
    </div>
  );
};
export default SequentialDetail;
